import { Ref, watch } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm, HekateDisplayField } from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class CreatorProgramProgressiveProfile extends CommonPreFilledProgressiveProfile {
  // eslint-disable-next-line class-methods-use-this
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    if (!formDefinition.value) {
      return;
    }
    super.realtimeBranchModifications({ formDefinition });

    const studyEngineeringVal = ExternalUtil.findDisplayFieldValOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.studyEngineering });

    const hideAll: HekateDisplayField[] = [
      ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.highLevelEdu }),
      ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.majorInSchool }),
    ];
    hideAll.forEach((field) => {
      field.componentName = 'hidden-field';
      field.isRequired = false;
    });

    watch(studyEngineeringVal, (newVal) => {
      if (newVal === 'yes') {
        hideAll.forEach((field) => {
          field.componentName = field.initialComponentName;
          field.isRequired = true;
        });
      } else {
        hideAll.forEach((field) => {
          field.componentName = 'hidden-field';
          field.val = '';
          field.isRequired = false;
        });
      }
    });
  }
}
